import { inject } from "@angular/core";
import { CognitoService } from "../services/cognito.service";
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from "@angular/router";
import { OrdersService } from "../services/orders.service";
import { VendorsService } from "@app/services/vendors.service";

export const VendorResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(VendorsService).fetchVendorById(route.paramMap.get("vendorId"));
};
